import React, { useState } from 'react';
import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';
import absoluteUrl from 'next-absolute-url/index';
import SearchPage from 'src/components/Search';
import ListingApis from 'src/api/listings';
import { IListings } from 'src/interface';
import useCustomSearchListings from 'src/hooks/api/listings/useCustomSearchListings';
import client from 'src/utils/axios';
import config from 'src/config';
import SearchPageBanner from 'src/components/Common/pageBanner';
// import { AdHorizontal } from '../../index';
// import AdBanner from '../../../components/Adsense';
import { generateDescriptionFromListings } from '../../../utils/helpers';

type Props = {
  canonicalUrl: string;
  listingsFromServer: IListings;
  pageName: string;
  description: string;
  query: any;
};

const baseUrl = `${config.apiUrl}`;
type Fetcher = {
  location?: string;
  category?: string;
};
const fetcher = async (url: string, query: Fetcher) => {
  const response = await client.get(`${baseUrl}/search?location=${query.location}&${url}`);
  return response.data;
};

const RentalAdsLocationPage = (props: Props) => {
  const { canonicalUrl, listingsFromServer, pageName, description, query } = props;
  const [viewItems, setViewItems] = useState(listingsFromServer?.per_page || 10);

  const shouldFetch = viewItems > 10 ? [`perPage=${viewItems}`, query] : null;

  const { Listings, canLoadMore, isLoading } = useCustomSearchListings(
    listingsFromServer,
    shouldFetch,
    viewItems,
    fetcher
  );
  return (
    <>
      <NextSeo
        canonical={canonicalUrl}
        title={pageName}
        description={description}
        openGraph={{
          url: canonicalUrl,
          title: pageName,
          description,
          images: [
            {
              url: 'https://rentable.pk/assets/logos/green-text-logo.png',
              alt: 'Rentable Pakistan',
            },
          ],
        }}
      />
      {/* <pre>{JSON.stringify(props, null, 2)}</pre> */}
      {/* <SearchPageBanner /> */}
      {/* <AdHorizontal>
        <AdBanner slotId="4100436110" />
      </AdHorizontal> */}
      <SearchPage
        Listings={Listings}
        canLoadMore={canLoadMore}
        isLoading={isLoading}
        setViewItems={setViewItems}
      />
      {/* <AdHorizontal>
        <AdBanner slotId="9529706829" />
      </AdHorizontal> */}
    </>
  );
};
export async function getStaticPaths() {
  return {
    paths: [
      { params: { location: 'islamabad' } },
      { params: { location: 'rawalpindi' } },
      { params: { location: 'lahore' } },
      { params: { location: 'karachi' } },
      { params: { location: 'peshawar' } },
      { params: { location: 'multan' } },
      { params: { location: 'gujranwala' } },
      { params: { location: 'sialkot' } },
      { params: { location: 'quetta' } },
    ],
    fallback: false,
  };
}
export const getStaticProps: GetStaticProps = async (ctx) => {
  const { params } = ctx;
  const result = await ListingApis.fetchSearchListings(params || {});
  return {
    props: {
      canonicalUrl: `https://www.rentable.pk/rent-ads/${params?.location}`,
      listingsFromServer: result.data.listings,
      pageName: `Rental Ads in ${params?.location}`,
      description: generateDescriptionFromListings(
        result.data.listings,
        'Rent ',
        ` in ${params?.location}`
      ),
      query: params,
      revalidate: 120,
    },
  };
};
export default RentalAdsLocationPage;
